/**
 * Copyright 2020 (c) Dominik Basner, Sotec GmbH (for VDW e.V.)
 * Copyright 2020 (c) Fabian Wilhelm, Sotec GmbH (for VDW e.V.)
 * Copyright 2020-2021 (c) Christian von Arnim, ISW University of Stuttgart (for umati and VDW e.V.)
 */
import JobStates from './ConstJobStates';
import UmatiColors from './ConstUmatiColors';

const JobStatesColor = {
  [JobStates.Initialized.toString()]: UmatiColors.Light,
  [JobStates.Running.toString()]: UmatiColors.Success,
  [JobStates.Ended.toString()]: UmatiColors.Info,
  [JobStates.Interrupted.toString()]: UmatiColors.Warning,
  [JobStates.Aborted.toString()]: UmatiColors.Danger
};

export default JobStatesColor;
